(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["box-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ADULT_RAW = 0.25, CHILD_RAW = 0.12, PORTION = 0.25; // kg Rohgewicht

  function init(root) {
    if (root.__rwbb) return; root.__rwbb = true;
    var DATA = window.RW_BOX_DATA;
    var I = DATA.i18n || {};
    var LOC = DATA.lang || 'de';
    try { (1).toLocaleString(LOC); } catch (e) { LOC = 'de'; }
    function fmt(s, o) { s = String(s == null ? '' : s); for (var k in o) { s = s.split('{' + k + '}').join(o[k]); } return s; }
    var state = { adults: 1, children: 0, occf: 5, occasion: 'mixed', umfangLabel: 'Wochenbedarf', diet: 1.0, cats: [], catWeight: {}, items: [], flash: {}, minTargetG: 0 };

    function $(s, c) { return (c || root).querySelector(s); }
    function $all(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
    function eur(cents) { return (cents / 100).toLocaleString(LOC, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
    function kg1(n) { return n.toLocaleString(LOC, { maximumFractionDigits: 1 }); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    // aria-pressed an Pills/Kacheln mit dem is-active-Zustand synchron halten (Screenreader)
    function syncPressedAll() {
      ['[data-umfang]', '[data-diet]', '[data-cat]'].forEach(function (sel) {
        $all(sel).forEach(function (x) { x.setAttribute('aria-pressed', x.classList.contains('is-active') ? 'true' : 'false'); });
      });
    }
    // Sticky-Leiste (mobil): sichtbar nur im Ergebnis, mit Inhalt, wenn der echte CTA nicht im Bild ist
    var stickyState = { step4: false, ctaVisible: true };
    function syncSticky() {
      var el = $('[data-rwbb-sticky]'); if (!el) return;
      el.hidden = !(stickyState.step4 && state.items.length > 0 && !stickyState.ctaVisible);
    }
    // Box-Zustand überlebt Reload (sessionStorage)
    var STORE_KEY = 'rwbb-box-v1';
    function saveState() {
      try {
        sessionStorage.setItem(STORE_KEY, JSON.stringify({
          adults: state.adults, children: state.children, occf: state.occf, occasion: state.occasion,
          umfangLabel: state.umfangLabel, diet: state.diet, cats: state.cats, catWeight: state.catWeight,
          items: state.items.map(function (it) { return { p: it.p, qty: it.qty, cat: it.cat }; }),
          built: state.items.length > 0
        }));
      } catch (e) {}
    }
    function grams(p) {
      if (p.dw) return p.dw; // festes Default-Gewicht (z.B. Leberkäse = 500 g), überschreibt Titel/Variante
      var m = (p.title + ' ' + p.variant).match(/(\d+[.,]?\d*)\s*(kg|g)\b/i);
      if (!m) return null;
      var n = parseFloat(m[1].replace(',', '.'));
      return /kg/i.test(m[2]) ? n * 1000 : n;
    }
    function totalKg() { return (state.adults * ADULT_RAW + state.children * CHILD_RAW) * state.occf * state.diet; }
    function scrollTop() { try { var y = root.getBoundingClientRect().top + window.pageYOffset - 80; window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' }); } catch (e) {} }

    function showStep(n) {
      $all('[data-step]').forEach(function (s) { s.hidden = s.getAttribute('data-step') != n; });
      var loader = $('[data-rwbb-loader]'); if (loader) loader.hidden = true;
      var pbar0 = $('.rwbb__progress'); if (pbar0) pbar0.style.display = '';
      var plab0 = $('[data-rwbb-steplabel]'); if (plab0) plab0.style.display = '';
      var skipped = state.cats.length < 2; // Verteilung (Schritt 3) wird übersprungen
      var tot, disp;
      if (n === 4) { tot = skipped ? 3 : 4; disp = tot; }
      else if (n === 3) { tot = 4; disp = 3; }
      else { tot = 4; disp = n; }
      var pr = $('[data-rwbb-progress]'); if (pr) pr.style.width = (disp / tot * 100) + '%';
      var lb = $('[data-rwbb-steplabel]'); if (lb) lb.textContent = fmt(I.steplabel, { x: disp, y: tot });
      stickyState.step4 = (n === 4); syncSticky();
    }

    // ---- Step 1: Bedarf ----
    function setOut(key) { var o = $('[data-out="' + key + '"]'); if (o) o.textContent = state[key]; }
    var estTimer = null;
    function updateEstimate(instant) {
      state.minTargetG = 0; // bei jeder Bedarfs-Änderung den manuellen Vergrößern-Boost zurücksetzen
      var el = $('[data-rwbb-estimate]'); if (!el) return;
      if (estTimer) { clearTimeout(estTimer); estTimer = null; }
      if (instant) { el.classList.remove('is-calc'); el.textContent = fmt(I.estimate, { kg: kg1(totalKg()) }); return; }
      el.classList.add('is-calc');
      el.textContent = I.estimating;
      estTimer = setTimeout(function () {
        estTimer = null;
        el.classList.remove('is-calc');
        el.textContent = fmt(I.estimate, { kg: kg1(totalKg()) });
      }, 500);
    }
    $all('[data-inc]').forEach(function (b) { b.addEventListener('click', function () { var k = b.getAttribute('data-inc'); state[k] = Math.min(20, state[k] + 1); setOut(k); updateEstimate(); }); });
    $all('[data-dec]').forEach(function (b) { b.addEventListener('click', function () { var k = b.getAttribute('data-dec'); var min = k === 'adults' ? 1 : 0; state[k] = Math.max(min, state[k] - 1); setOut(k); updateEstimate(); }); });

    $all('[data-umfang]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.occf = parseFloat(b.getAttribute('data-occf'));
        state.occasion = b.getAttribute('data-occasion');
        state.umfangLabel = b.textContent.trim();
        $all('[data-umfang]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        syncPressedAll();
        updateEstimate();
      });
    });
    $all('[data-diet]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.diet = parseFloat(b.getAttribute('data-factor'));
        $all('[data-diet]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        syncPressedAll();
        updateEstimate();
      });
    });
    // ---- Step 3: Verteilung (Chips wenig/mittel/viel) ----
    var CHIPS = [{ w: 1, label: I.chip_low }, { w: 2, label: I.chip_mid }, { w: 3, label: I.chip_high }];
    // Chip-Zustände in-place aktualisieren (statt Neu-Render) → Farb-Transition + Pop laufen sichtbar
    function refreshChips() {
      $all('[data-weights] .rwbb__weight').forEach(function (row) {
        var c = row.getAttribute('data-cat');
        $all('[data-w]', row).forEach(function (btn) {
          var bw = parseInt(btn.getAttribute('data-w'), 10);
          var active = bw === (state.catWeight[c] || 2);
          var was = btn.classList.contains('is-active');
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
          if (active && !was) { btn.classList.remove('rwbb__chip--in'); void btn.offsetWidth; btn.classList.add('rwbb__chip--in'); }
        });
      });
    }
    function renderChips() {
      var box = $('[data-weights]'); if (!box) return;
      box.innerHTML = '';
      if (state.cats.length < 2) return;
      state.cats.forEach(function (cat) {
        if (state.catWeight[cat] == null) state.catWeight[cat] = 2;
        var row = document.createElement('div');
        row.className = 'rwbb__weight';
        row.setAttribute('data-cat', cat);
        var chips = CHIPS.map(function (o) { return '<button type="button" class="rwbb__chip" data-w="' + o.w + '">' + o.label + '</button>'; }).join('');
        row.innerHTML = '<span class="rwbb__weight-label">' + (DATA.labels[cat] || cat) + '</span><div class="rwbb__chips">' + chips + '</div>';
        var btns = Array.prototype.slice.call(row.querySelectorAll('[data-w]'));
        btns.forEach(function (b) {
          var w = parseInt(b.getAttribute('data-w'), 10);
          if (w === state.catWeight[cat]) b.classList.add('is-active');
          b.setAttribute('aria-pressed', w === state.catWeight[cat] ? 'true' : 'false');
          b.addEventListener('click', function () {
            if (w === 3) { state.cats.forEach(function (oc) { if (oc !== cat && state.catWeight[oc] === 3) state.catWeight[oc] = 2; }); }
            state.catWeight[cat] = w;
            refreshChips();
          });
        });
        box.appendChild(row);
      });
    }
    function syncNext2() {
      var n2 = $('[data-next2]'); if (!n2) return;
      var n = state.cats.length;
      n2.disabled = n === 0;
      n2.textContent = n === 0 ? I.next : (n === 1 ? fmt(I.next_one, { n: 1 }) : fmt(I.next_many, { n: n }));
    }
    $all('[data-cat]').forEach(function (b) {
      b.addEventListener('click', function () {
        var c = b.getAttribute('data-cat');
        var i = state.cats.indexOf(c);
        if (i > -1) { state.cats.splice(i, 1); b.classList.remove('is-active'); }
        else { state.cats.push(c); b.classList.add('is-active'); }
        syncPressedAll();
        syncNext2();
      });
    });

    // ---- Navigation ----
    $all('[data-next]').forEach(function (b) { b.addEventListener('click', function () { showStep(2); scrollTop(); }); });
    $('[data-next2]').addEventListener('click', function () {
      if (state.cats.length >= 2) { renderChips(); showStep(3); scrollTop(); }
      else { state.minTargetG = 0; runBuild(); }
    });
    $all('[data-prev]').forEach(function (b) {
      b.addEventListener('click', function () {
        var cur = parseInt(b.closest('[data-step]').getAttribute('data-step'), 10);
        var target = cur === 4 ? (state.cats.length >= 2 ? 3 : 2) : cur - 1;
        if (target === 3) renderChips();
        showStep(target); scrollTop();
      });
    });

    // ---- Produkt-Pool je Sorte (Reihenfolge = Collection-Sortierung, d.h. Bestseller/Beliebtheit als Fallback) ----
    function poolFor(cat) {
      var pool = (DATA.categories[cat] || []).map(function (p) { return Object.assign({}, p, { g: grams(p) }); }).filter(function (p) { return p.g; });
      if (state.occasion === 'grill') {
        if (cat === 'wurst') { var wp = pool.filter(function (p) { return (!p.aufschnitt && !p.trocken && !p.lk) || p.grill; }); if (wp.length) pool = wp; } // Grill: Aufschnitte, Trockenwürste (Landjäger) und Leberkäse raus (Ausnahme: Verwendung:Grillen, z.B. Rinderspeck); übrige echte Würste bleiben
        else { var gs = pool.filter(function (p) { return p.grillstrict; }); if (gs.length >= 2) pool = gs; else { var gp = pool.filter(function (p) { return p.grill; }); if (gp.length >= 2) pool = gp; } } // Grill: echte Grill-Teile (Verwendung:Grillen, z.B. Steaks) bevorzugen; Schnitzel/Kurzbraten nur als Fallback, wenn <2 echte Grill-Teile da sind
      }
      if (state.diet >= 1.3) { var lp = pool.filter(function (p) { return p.lean; }), rest = pool.filter(function (p) { return !p.lean; }); if (lp.length) pool = lp.concat(rest); } // Eiweißreich: magere Teile zuerst, Rest als Auffüller (damit große Boxen ihr Gewicht erreichen)
      return pool;
    }
    // Nur ein Leberkäse-Produkt je Box (Leberkäse ODER Käse-Leberkäse, nie beide zusammen)
    function hasLk(picks) { for (var k in picks) { if (picks[k] && picks[k].p && picks[k].p.lk) return true; } return false; }
    // Stückzahl-Cap fürs automatische Befüllen (Mengenregler bleibt für den Nutzer frei)
    function capOf(p, cat, isMost) {
      if (p.spez) return isMost ? 3 : 1; // Spezialität sparsam, außer die Sorte steht auf "Am meisten"
      var base = cat === 'wurst' ? 2 : 3; // Wurst und Aufschnitt 2, Frischfleisch 3
      return base * (state.capMul || 1);  // große Boxen (Monatsvorrat): mehr je Produkt zulassen, sonst wird das Zielgewicht nie erreicht
    }
    // Breite zuerst (je ein Stück der beliebtesten Produkte), dann Tiefe (Stückzahl erhöhen, gedeckelt)
    function assembleSort(cat, target, maxDistinct) {
      var pool = poolFor(cat);
      var picks = {}, sum = 0;
      if (!pool.length) return { picks: picks, sum: 0 };
      var isMost = (state.catWeight[cat] || 2) === 3;
      var fit = pool.filter(function (p) { return p.g <= target * 1.5; }); // keine Packungen weit über dem Sorten-Ziel (z.B. ganzes Hähnchen in kleiner Box)
      if (fit.length) pool = fit;
      for (var i = 0; i < pool.length && sum < target; i++) {
        if (Object.keys(picks).length >= maxDistinct) break;
        var p = pool[i];
        if (capOf(p, cat, isMost) < 1 || picks[p.id]) continue;
        if (p.lk && hasLk(picks)) continue; // nicht Leberkäse UND Käse-Leberkäse zusammen
        picks[p.id] = { p: p, qty: 1, on: true, cat: cat }; sum += p.g;
      }
      var guard = 0;
      while (sum < target && guard < 600) {
        guard++; var added = false;
        for (var j = 0; j < pool.length && sum < target; j++) {
          var pp = pool[j], it = picks[pp.id];
          if (it && it.qty < capOf(pp, cat, isMost)) { it.qty++; sum += pp.g; added = true; }
        }
        if (!added) break;
      }
      return { picks: picks, sum: sum };
    }
    // Eine Packung nachlegen (Tiefe vor Breite) für die Auffüll-Sorte
    function addOnePack(cat, picks, maxDistinct, maxPackG) {
      var pool = poolFor(cat), isMost = (state.catWeight[cat] || 2) === 3;
      for (var i = 0; i < pool.length; i++) { var it = picks[pool[i].id]; if (it && it.qty < capOf(pool[i], cat, isMost)) { it.qty++; return pool[i].g; } }
      if (Object.keys(picks).length < maxDistinct) {
        for (var j = 0; j < pool.length; j++) { var p = pool[j]; if (!picks[p.id] && capOf(p, cat, isMost) >= 1 && (!maxPackG || p.g <= maxPackG) && !(p.lk && hasLk(picks))) { picks[p.id] = { p: p, qty: 1, on: true, cat: cat }; return p.g; } }
      }
      return 0;
    }
    function runBuild() {
      var totalG = Math.max(totalKg() * 1000, state.minTargetG || 0);
      state.capMul = Math.max(1, Math.ceil(totalG / 8000)); // Stückzahl-Caps für große Boxen hochskalieren (~ +1 Runde je 8 kg)
      // Grillabend: Wurst/Aufschnitt spielt kleinere Rolle → Wurst-Gewicht dämpfen (Rest geht ans Fleisch)
      function effW(cat) { var w = state.catWeight[cat] || 2; if (state.occasion === 'grill' && cat === 'wurst') w *= 0.4; return w; }
      // Mindestpackung je gewählter Sorte → wie viele Sorten passen ins Zielgewicht
      var minPacks = [];
      state.cats.forEach(function (cat) { var pool = poolFor(cat); if (pool.length) { var mn = pool[0].g; pool.forEach(function (p) { if (p.g < mn) mn = p.g; }); minPacks.push(mn); } });
      var avgMin = minPacks.length ? minPacks.reduce(function (a, b) { return a + b; }, 0) / minPacks.length : 350;
      var maxSorten = Math.max(1, Math.floor(totalG / avgMin));
      // nach Gewichtung sortieren (viel zuerst); viel wird nie gestrichen
      var sorted = state.cats.slice().sort(function (a, b) { return effW(b) - effW(a); });
      var keep = [], dropped = [];
      sorted.forEach(function (cat) {
        var isViel = (state.catWeight[cat] || 2) === 3;
        if (keep.length < maxSorten || isViel) keep.push(cat); else dropped.push(cat);
      });
      var keepOrdered = state.cats.filter(function (c) { return keep.indexOf(c) > -1; });
      var sumW = 0; keepOrdered.forEach(function (c) { sumW += effW(c); }); if (sumW <= 0) sumW = 1;
      var itemsMap = {}, catSum = {}, totalSum = 0;
      keepOrdered.forEach(function (cat) {
        var target = totalG * (effW(cat) / sumW);
        var cpool = poolFor(cat);
        var avgPack = cpool.length ? cpool.reduce(function (a, p) { return a + p.g; }, 0) / cpool.length : 500;
        // Anzahl verschiedener Produkte skaliert mit dem Sorten-Ziel (sonst erreicht eine große Box nie ihr Gewicht)
        var maxDistinct = Math.max(2, Math.min(cpool.length || 1, Math.ceil(target / Math.max(avgPack, 1))));
        var r = assembleSort(cat, target, maxDistinct);
        itemsMap[cat] = r.picks; catSum[cat] = r.sum; totalSum += r.sum;
      });
      // Global proportional auffüllen bis zum Zielgewicht: immer die Sorte mit dem größten Rückstand zuerst (nicht nur eine)
      var gguard = 0;
      while (totalSum < totalG && gguard < 4000) {
        gguard++;
        var bestCat = null, worstDef = -1;
        keepOrdered.forEach(function (cat) {
          var tgt = totalG * (effW(cat) / sumW);
          var def = tgt - (catSum[cat] || 0);
          if (def > worstDef) { worstDef = def; bestCat = cat; }
        });
        if (!bestCat) break;
        var ag = addOnePack(bestCat, itemsMap[bestCat], 40, totalG);
        if (!ag) {
          var moved = 0;
          for (var qi = 0; qi < keepOrdered.length; qi++) { var a2 = addOnePack(keepOrdered[qi], itemsMap[keepOrdered[qi]], 40, totalG); if (a2) { catSum[keepOrdered[qi]] += a2; totalSum += a2; moved = 1; break; } }
          if (!moved) break;
        } else { catSum[bestCat] += ag; totalSum += ag; }
      }
      var items = [];
      keepOrdered.forEach(function (cat) { Object.keys(itemsMap[cat]).forEach(function (k) { items.push(itemsMap[cat][k]); }); });
      state.items = items;
      // Hinweise (Mix-Problem und/oder Spezialität)
      var spez = null;
      items.forEach(function (it) { if (it.p.spez && (state.catWeight[it.cat] || 2) !== 3 && !spez) spez = it.p; });
      var messages = [];
      if (dropped.length) messages.push(fmt(I.notice_mix, { n: state.cats.length, kg: kg1(state.cats.length * avgMin / 1000) }));
      if (spez) messages.push(fmt(I.notice_spez, { produkt: spez.title }));
      var notice = $('[data-rwbb-notice]');
      if (notice) {
        notice.innerHTML = '';
        if (messages.length) {
          messages.forEach(function (m) { var pEl = document.createElement('p'); pEl.style.margin = '0'; pEl.textContent = m; notice.appendChild(pEl); });
          if (dropped.length) {
            var needG = state.cats.length * avgMin * 1.05; // Zielgewicht so erhöhen, dass alle Sorten reinpassen
            var bb = document.createElement('button');
            bb.type = 'button'; bb.className = 'link subheading rwbb__notice-btn'; bb.textContent = I.enlarge;
            bb.addEventListener('click', function () { state.minTargetG = needG; runBuild(); });
            notice.appendChild(bb);
          }
          notice.hidden = false;
        } else notice.hidden = true;
      }
      // Lade-Animation (~4s) mit wechselnden Texten, dann Ergebnis
      $all('[data-step]').forEach(function (s) { s.hidden = true; });
      stickyState.step4 = false; syncSticky();
      var loader = $('[data-rwbb-loader]'); if (loader) loader.hidden = false;
      var pbar = $('.rwbb__progress'); if (pbar) pbar.style.display = 'none';
      var plab = $('[data-rwbb-steplabel]'); if (plab) plab.style.display = 'none';
      var lmsgs = [I.loader1, I.loader2, I.loader3];
      var lt = $('[data-rwbb-loader-text]'), li = 0;
      if (lt) lt.textContent = lmsgs[0];
      var msgTimer = setInterval(function () { li = Math.min(li + 1, lmsgs.length - 1); if (lt) lt.textContent = lmsgs[li]; }, 1300);
      scrollTop();
      setTimeout(function () {
        clearInterval(msgTimer);
        if (loader) loader.hidden = true;
        renderResult();
        fillDelivery();
        showStep(4);
        scrollTop();
      }, 4000);
    }
    $('[data-build]').addEventListener('click', function () { state.minTargetG = 0; runBuild(); });

    function fillDelivery() {
      var el = $('[data-rwbb-delivery]'); if (!el) return;
      var t = DATA.delivery || {};
      var now = new Date();
      var nowV = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Vienna' }));
      var deadline = new Date(nowV);
      var dus = (7 - nowV.getDay()) % 7;
      deadline.setDate(nowV.getDate() + dus); deadline.setHours(23, 59, 59, 999);
      if (deadline <= nowV) deadline.setDate(deadline.getDate() + 7);
      var delivery = new Date(deadline); delivery.setDate(deadline.getDate() + 4);
      var totalMin = Math.max(0, Math.floor((deadline - nowV) / 60000));
      var totalH = Math.floor(totalMin / 60), min = totalMin % 60, days = Math.ceil(totalH / 24);
      function pl(v, a, b) { return v === 1 ? a : b; }
      var timeText = totalH > 48 ? days + ' ' + pl(days, t.d1, t.dn) : totalH + ' ' + pl(totalH, t.h1, t.hn) + ' ' + min + ' ' + pl(min, t.m1, t.mn);
      var dateText;
      try { dateText = delivery.toLocaleDateString(LOC, { day: '2-digit', month: '2-digit', year: 'numeric' }); }
      catch (e) { dateText = delivery.toLocaleDateString('de', { day: '2-digit', month: '2-digit', year: 'numeric' }); }
      var ord = $('[data-rwbb-deliv-order]'), dt = $('[data-rwbb-deliv-date]');
      if (ord) ord.textContent = String(t.orderText || '').split('{zeit}').join(timeText);
      if (dt) dt.textContent = String(t.dateText || '').split('{datum}').join(dateText);
    }

    function personLine() {
      var parts = [];
      parts.push(state.adults === 1 ? I.adult_one : fmt(I.adult_many, { n: state.adults }));
      if (state.children > 0) parts.push(state.children === 1 ? I.child_one : fmt(I.child_many, { n: state.children }));
      return parts.join(' ' + I.and + ' ') + ' (' + state.umfangLabel + ')';
    }
    function trashSvg() {
      return '<img src="https://cdn.shopify.com/s/files/1/0979/2025/4281/files/reinweide-delete-icon.svg?v=1782587332" alt="" width="16" height="16" loading="lazy">';
    }
    function plusSvg() { return '<svg class="rwbb__pm" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 3.2v9.6M3.2 8h9.6" stroke="currentColor" stroke-width="1.4" stroke-linecap="square"/></svg>'; }
    function minusSvg() { return '<svg class="rwbb__pm" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3.2 8h9.6" stroke="currentColor" stroke-width="1.4" stroke-linecap="square"/></svg>'; }
    function syncMore() { var panel = $('[data-rwbb-more]'); if (panel && !panel.hidden) renderMore(); }

    function renderResult() {
      var list = $('[data-rwbb-list]');
      var order = Object.keys(DATA.categories);
      state.items.sort(function (a, b) { return order.indexOf(a.cat) - order.indexOf(b.cat); });
      var et = $('[data-rwbb-emptitle]'); if (et) et.textContent = (state.adults + state.children) > 1 ? I.emp_plural : I.emp_single;
      var pl = $('[data-rwbb-personline]'); if (pl) pl.textContent = personLine();
      list.innerHTML = '';
      var empty = $('[data-rwbb-empty]'), moreBtn = $('[data-rwbb-moretoggle]'), morePanel = $('[data-rwbb-more]'),
          total = $('.rwbb__total', root), avg = $('[data-rwbb-avg]'), por = $('[data-rwbb-portions]'), addcart = $('[data-addcart]');
      var isEmpty = state.items.length === 0;
      if (empty) empty.hidden = !isEmpty;
      list.hidden = isEmpty;
      if (total) total.hidden = isEmpty;
      if (avg) avg.hidden = isEmpty;
      if (por) por.hidden = isEmpty;
      if (moreBtn) moreBtn.hidden = isEmpty;
      if (isEmpty && morePanel) morePanel.hidden = true;
      if (addcart) addcart.disabled = isEmpty;
      var cards = $('[data-rwbb-infocards]');
      if (cards) cards.hidden = isEmpty;
      syncSticky();
      if (isEmpty) { updateTotal(); return; }

      var cols = {}, colCount = 0;
      state.items.forEach(function (it) {
        if (!cols[it.cat]) {
          var col = document.createElement('div'); col.className = 'rwbb__col';
          var head = document.createElement('div'); head.className = 'rwbb__cathead';
          head.textContent = (DATA.labels && DATA.labels[it.cat]) || '';
          col.appendChild(head); cols[it.cat] = col; colCount++;
          list.appendChild(col);
        }
        var card = document.createElement('div');
        card.className = 'rwbb__card' + (state.flash[it.p.id] ? ' rwbb__card--pop' : '');
        if (state.flash[it.p.id]) delete state.flash[it.p.id];
        card.innerHTML =
          (it.p.url
            ? '<a class="rwbb__card-media" href="' + esc(it.p.url) + '" target="_blank" rel="noopener">' + (it.p.img ? '<img src="' + esc(it.p.img) + '" alt="" loading="lazy">' : '') + '</a>'
            : '<span class="rwbb__card-media">' + (it.p.img ? '<img src="' + esc(it.p.img) + '" alt="" loading="lazy">' : '') + '</span>') +
          '<div class="rwbb__card-body">' +
            '<span class="rwbb__card-title">' + esc(it.p.title) + '</span>' +
            '<span class="rwbb__card-price">' + eur(it.p.cents) + '</span>' +
            (it.p.g ? '<span class="rwbb__card-kilo">' + eur(it.p.cents / (it.p.g / 1000)) + ' / kg</span>' : '') +
          '</div>' +
          '<div class="rwbb__card-foot">' +
            '<span class="rwbb__card-qty"><button type="button" data-q="-">' + minusSvg() + '</button><output>' + it.qty + '</output><button type="button" data-q="+">' + plusSvg() + '</button></span>' +
            '<button type="button" class="rwbb__card-trash" data-trash aria-label="' + esc(I.remove_aria) + '">' + trashSvg() + '</button>' +
          '</div>';
        card.querySelector('[data-trash]').addEventListener('click', function () {
          card.classList.add('rwbb__card--out');
          setTimeout(function () {
            var ix = state.items.indexOf(it); if (ix > -1) state.items.splice(ix, 1);
            renderResult(); syncMore();
          }, 200);
        });
        var out = card.querySelector('output');
        card.querySelector('[data-q="+"]').addEventListener('click', function () { it.qty++; out.textContent = it.qty; updateTotal(); syncMore(); });
        card.querySelector('[data-q="-"]').addEventListener('click', function () { if (it.qty > 1) { it.qty--; out.textContent = it.qty; updateTotal(); syncMore(); } });
        cols[it.cat].appendChild(card);
      });
      updateTotal();
    }

    function updateTotal() {
      var cents = 0, g = 0;
      state.items.forEach(function (it) { cents += it.p.cents * it.qty; g += (it.p.g || 0) * it.qty; });
      var tt = $('[data-rwbb-total]'); if (tt) tt.textContent = eur(cents);
      var kg = g / 1000;
      var avg = $('[data-rwbb-avg]');
      if (avg) { avg.textContent = kg > 0 ? fmt(I.avg, { kg: kg1(kg), preis: eur(cents / kg) }) : ''; }
      var por = $('[data-rwbb-portions]');
      var hasP = kg > 0;
      var portions = Math.max(1, Math.round(kg / PORTION));
      var ppText = (hasP && cents > 0) ? fmt(I.portion_each, { preis: eur(cents / portions) }) : '';
      if (por) por.textContent = hasP ? fmt(I.portions, { n: portions, preis: eur(cents / portions) }) : '';
      var st = $('[data-rwbb-sticky-total]'); if (st) st.textContent = eur(cents);
      var ss = $('[data-rwbb-sticky-sub]'); if (ss) ss.textContent = ppText;
      syncSticky();
      saveState();
    }

    // ---- Weitere Produkte (kompakte Liste, + wird zum Mengenregler) ----
    function findItem(id) { for (var i = 0; i < state.items.length; i++) { if (state.items[i].p.id === id) return state.items[i]; } return null; }
    // Panel-Aktion ausführen und dabei die Scroll-Position der geklickten Zeile halten (kein Hochspringen)
    function panelAction(pid, mutate) {
      var panel = $('[data-rwbb-more]');
      var before = panel ? panel.querySelector('[data-pid="' + pid + '"]') : null;
      var top = before ? before.getBoundingClientRect().top : null;
      mutate();
      renderResult();
      renderMore();
      if (top != null) {
        var p2 = $('[data-rwbb-more]');
        var after = p2 ? p2.querySelector('[data-pid="' + pid + '"]') : null;
        if (after) {
          var d = after.getBoundingClientRect().top - top; if (d) window.scrollBy(0, d);
          var ctrl = after.querySelector('.rwbb__more-add, .rwbb__more-qty');
          if (ctrl) ctrl.classList.add('rwbb__ctrl--in');
        }
      }
    }
    function renderMore() {
      var box = $('[data-rwbb-more]'); if (!box) return;
      box.innerHTML = '';
      var any = false;
      state.cats.forEach(function (cat) {
        var prods = (DATA.categories[cat] || []);
        if (!prods.length) return;
        var head = document.createElement('div');
        head.className = 'rwbb__more-cat';
        head.textContent = DATA.labels[cat] || cat;
        box.appendChild(head);
        prods.forEach(function (p) {
          any = true;
          var g = grams(p);
          var item = findItem(p.id);
          var qty = item ? item.qty : 0;
          var row = document.createElement('div');
          row.className = 'rwbb__more-row';
          row.setAttribute('data-pid', p.id);
          var control = qty === 0
            ? '<button type="button" class="rwbb__more-add" data-madd aria-label="' + esc(I.add_aria) + '">' + plusSvg() + '</button>'
            : '<span class="rwbb__more-qty"><button type="button" data-mq="-">' + minusSvg() + '</button><output>' + qty + '</output><button type="button" data-mq="+">' + plusSvg() + '</button></span>';
          var thumbInner = (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '');
          row.innerHTML =
            (p.url
              ? '<a class="rwbb__more-thumb" href="' + esc(p.url) + '" target="_blank" rel="noopener">' + thumbInner + '</a>'
              : '<span class="rwbb__more-thumb">' + thumbInner + '</span>') +
            '<span class="rwbb__more-info"><span class="rwbb__more-name">' + esc(p.title) + '</span><span class="rwbb__more-price">' + eur(p.cents) + '</span></span>' +
            control;
          var madd = row.querySelector('[data-madd]');
          if (madd) madd.addEventListener('click', function () { panelAction(p.id, function () { state.flash[p.id] = true; state.items.push({ p: Object.assign({}, p, { g: g }), qty: 1, on: true, cat: cat }); }); });
          var qp = row.querySelector('[data-mq="+"]'), qm = row.querySelector('[data-mq="-"]');
          if (qp) qp.addEventListener('click', function () { panelAction(p.id, function () { var it = findItem(p.id); if (it) it.qty++; }); });
          if (qm) qm.addEventListener('click', function () { panelAction(p.id, function () { var it = findItem(p.id); if (!it) return; if (it.qty > 1) it.qty--; else { var ix = state.items.indexOf(it); if (ix > -1) state.items.splice(ix, 1); } }); });
          box.appendChild(row);
        });
      });
      if (!any) { var e = document.createElement('p'); e.className = 'rwbb__more-cat'; e.textContent = I.more_none; box.appendChild(e); }
    }
    var moreToggle = $('[data-rwbb-moretoggle]');
    if (moreToggle) {
      moreToggle.addEventListener('click', function () {
        var panel = $('[data-rwbb-more]'); if (!panel) return;
        if (panel.hidden) {
          renderMore(); panel.hidden = false; moreToggle.textContent = I.more_close;
        } else {
          panel.classList.add('rwbb__more--out');
          moreToggle.textContent = I.more_open;
          setTimeout(function () { panel.hidden = true; panel.classList.remove('rwbb__more--out'); }, 200);
        }
      });
    }

    var restart = $('[data-rwbb-restart]');
    if (restart) restart.addEventListener('click', function () { showStep(1); scrollTop(); });

    // ---- In den Warenkorb (echte Varianten-IDs als Positionen, Abo-fähig) ----
    $('[data-addcart]').addEventListener('click', function () {
      var btn = this;
      var items = state.items.map(function (it) { return { id: it.p.id, quantity: it.qty }; });
      if (!items.length) return;
      btn.disabled = true; btn.textContent = I.adding;
      var drawer = document.querySelector('cart-drawer');
      var useDrawer = drawer && typeof drawer.renderContents === 'function';
      var body = { items: items };
      if (useDrawer) { body.sections = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text']; body.sections_url = window.location.pathname; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (useDrawer) {
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            drawer.renderContents(res);
            btn.disabled = false; btn.textContent = I.addcart;
          } else { window.location.href = '/cart'; }
        })
        .catch(function () { btn.disabled = false; btn.textContent = I.addcart; alert(I.cart_error); });
    });

    // Sticky-Leiste: erscheint nur, wenn der echte CTA aus dem Viewport gescrollt ist; Klick löst den Haupt-Button aus
    var stickyCart = $('[data-rwbb-sticky-cart]');
    if (stickyCart) stickyCart.addEventListener('click', function () { var b = $('[data-addcart]'); if (b && !b.disabled) b.click(); });
    if ('IntersectionObserver' in window) {
      var mainCta = $('[data-addcart]');
      if (mainCta) new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { stickyState.ctaVisible = en.isIntersecting; });
        syncSticky();
      }, { threshold: 0 }).observe(mainCta);
    }

    // Gespeicherte Box wiederherstellen (Reload/Zurückkommen) — sonst normal bei Schritt 1 starten
    function restoreState() {
      try {
        var raw = sessionStorage.getItem(STORE_KEY); if (!raw) return false;
        var s = JSON.parse(raw);
        if (!s || !s.built || !s.items || !s.items.length) return false;
        var valid = {};
        Object.keys(DATA.categories).forEach(function (c) { (DATA.categories[c] || []).forEach(function (p) { valid[p.id] = 1; }); });
        var items = s.items.filter(function (it) { return it && it.p && valid[it.p.id]; });
        if (!items.length) return false;
        state.adults = s.adults || 1; state.children = s.children || 0;
        state.occf = s.occf || 5; state.occasion = s.occasion || 'mixed';
        state.umfangLabel = s.umfangLabel || 'Wochenbedarf'; state.diet = s.diet || 1;
        state.cats = s.cats || []; state.catWeight = s.catWeight || {};
        state.items = items.map(function (it) { return { p: it.p, qty: it.qty || 1, on: true, cat: it.cat }; });
        setOut('adults'); setOut('children');
        $all('[data-umfang]').forEach(function (x) { x.classList.toggle('is-active', parseFloat(x.getAttribute('data-occf')) === state.occf); });
        $all('[data-diet]').forEach(function (x) { x.classList.toggle('is-active', parseFloat(x.getAttribute('data-factor')) === state.diet); });
        $all('[data-cat]').forEach(function (x) { x.classList.toggle('is-active', state.cats.indexOf(x.getAttribute('data-cat')) > -1); });
        syncNext2();
        renderResult(); fillDelivery(); showStep(4);
        return true;
      } catch (e) { return false; }
    }

    var restored = restoreState();
    var actU = $('[data-umfang].is-active');
    if (!restored && actU) state.umfangLabel = actU.textContent.trim();
    updateEstimate(true);
    syncPressedAll();
    syncNext2();
    if (!restored) showStep(1);
  }

  function initAll(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-rwbb]'), init); }
  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(scope) {
    var els = (scope || document).querySelectorAll('.rw-compare:not([data-obs])');
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-obs', '');
      el.classList.add('is-ready');
      if (!('IntersectionObserver' in window)) { el.classList.add('is-visible'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (x) {
          if (x.isIntersecting) { x.target.classList.add('is-visible'); io.unobserve(x.target); }
        });
      }, { threshold: 0.2 });
      io.observe(el);
    });
  }
  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.getAttribute('data-rw-init')) return;
    root.setAttribute('data-rw-init', '1');

    var slider = root.querySelector('.rw-reviews-slider');
    if (!slider) return;
    var cards = Array.prototype.slice.call(slider.querySelectorAll('.rw-review-card'));
    if (!cards.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobile = window.matchMedia ? window.matchMedia('(max-width: 767px)').matches : (window.innerWidth < 768);
    var paused = false, speed = 0.6, period = 0, started = false;
    var isDown = false, startX = 0, sl = 0;

    root.classList.add('is-ready');

    function measure() {
      var gap = parseFloat(getComputedStyle(slider).columnGap || getComputedStyle(slider).gap) || 14;
      period = 0;
      cards.forEach(function (c) { period += c.getBoundingClientRect().width + gap; });
      return gap;
    }
    function addClones(gap) {
      var covered = 0, i = 0;
      while (covered < slider.clientWidth + gap && i < cards.length) {
        var cl = cards[i].cloneNode(true);
        cl.setAttribute('aria-hidden', 'true');
        slider.appendChild(cl);
        covered += cards[i].getBoundingClientRect().width + gap;
        i++;
      }
    }
    function tick() {
      if (!paused && period > 1) {
        slider.scrollLeft += speed;
        if (slider.scrollLeft >= period) slider.scrollLeft -= period;
      }
      requestAnimationFrame(tick);
    }
    function startMobile() {
      var clone = cards[0].cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      slider.appendChild(clone);
      slider.scrollLeft = 0;

      var timer = null, settle = null, auto = false;

      function leftOf(el) { return el.offsetLeft - slider.offsetLeft; }
      function nearest() {
        var x = slider.scrollLeft, best = 0, bestD = Infinity;
        cards.concat([clone]).forEach(function (el, i) {
          var d = Math.abs(leftOf(el) - x);
          if (d < bestD) { bestD = d; best = i; }
        });
        return best;
      }
      function reset() { auto = true; slider.scrollLeft = 0; }
      function plan() { clearTimeout(timer); timer = setTimeout(step, 5000); }
      function step() {
        var i = nearest() + 1;
        if (i > cards.length) { reset(); plan(); return; }
        auto = true;
        slider.scrollTo({ left: leftOf(i < cards.length ? cards[i] : clone), behavior: 'smooth' });
        if (i === cards.length) setTimeout(reset, 650);
        plan();
      }

      slider.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () {
          if (auto) { auto = false; return; }
          if (nearest() === cards.length) reset();
          plan();
        }, 150);
      }, { passive: true });

      ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
        slider.addEventListener(ev, function () { clearTimeout(timer); }, { passive: true });
      });
      ['touchend', 'touchcancel', 'pointercancel'].forEach(function (ev) {
        slider.addEventListener(ev, plan, { passive: true });
      });

      plan();
    }
    function startLoop() {
      if (started) return;
      started = true;
      var gap = measure();
      if (!reduce) {
        if (mobile) { startMobile(); }
        else { addClones(gap); slider.scrollLeft = 0; requestAnimationFrame(tick); }
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { root.classList.add('is-visible'); startLoop(); io.unobserve(root); }
        });
      }, { threshold: 0.15 });
      io.observe(root);
    } else {
      root.classList.add('is-visible');
      startLoop();
    }

    if (!mobile) {
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { if (!isDown) paused = false; });
      slider.addEventListener('mousedown', function (e) {
        isDown = true; paused = true; slider.classList.add('is-dragging');
        startX = e.pageX - slider.offsetLeft; sl = slider.scrollLeft; e.preventDefault();
      });
      window.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false; slider.classList.remove('is-dragging'); paused = false;
      });
      slider.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - slider.offsetLeft;
        slider.scrollLeft = sl - (x - startX) * 1.4;
      });
      slider.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      slider.addEventListener('touchend', function () { paused = false; });
    }
  }

  function initAll(scope) {
    var els = (scope || document).querySelectorAll('[data-rw-reviews]');
    Array.prototype.forEach.call(els, setup);
  }
  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
